import moment from "moment";
import "moment-duration-format";
moment.locale("de");
